import React from 'react';
import { Box, Button, makeStyles } from "@material-ui/core";
import colors from '../colours/colours.js'

// Helper function
import postData from '../functions/post_data.js';

const ButtonStyles = makeStyles({
    buttonStyle: {
        borderRadius: "3em",
        backgroundColor: colors[0],
        color: "white",
        fill: "white",
        border: '1px solid',
        maxHeight: '40px',
        fontFamily: 'Noto Sans',
        fontWeight: 'bold',
        fontSize: 'calc(7px + 0.3vw)',
        '&:hover': {
            backgroundColor: "white",
            color: colors[0],
            fill: colors[0]
        }
    },
    boxStyle: {
        margin: '2px'
    }
});

function EkiSVG(props) {
    return (
        <svg width="140" height="auto" viewBox="0 0 171 24" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
            <g fill-rule="evenodd">
                <path d="M0 23.699h17.799l.994-6.827h-1.506c-2.229 4.15-2.801 5.323-5.632 5.323h-.662c-1.566 0-2.32-.39-2.32-2.015v-6.466h2.5c1.416 0 1.747.692 1.988 2.797h1.415V9.113h-1.415c-.24 2.105-.572 2.797-1.988 2.797h-2.5V4.09h2.59c2.892 0 3.645 1.083 5.271 4.481H17.8l-.15-5.985H0V3.94c1.958.21 2.078.48 2.078 2.015V20.33c0 1.533-.12 1.804-2.078 2.014V23.7zm27.737-8.511l5.03 8.51h6.384v-.871l-6.294-10.045 3.192-3.068c.813-.812 1.536-.962 2.53-1.083V7.368h-7.017v1.263c1.385.15 1.777.361 1.777.903 0 .391-.181.782-1.024 1.533l-4.578 4.12zm-6.385 6.165c0 .902-.482.992-1.596 1.083v1.263h9.396v-1.263c-1.114-.09-1.596-.18-1.596-1.083V.151h-1.054l-6.746 1.353v1.022l1.596.812v18.015zM47.614 7.068h-1.085l-6.716 1.804v.933l1.597 1.022v10.526c0 .902-.482.992-1.597 1.083v1.263h9.397v-1.263c-1.115-.09-1.596-.18-1.596-1.083V7.068zm-3.012-1.113c1.988 0 3.192-1.384 3.192-2.978C47.794 1.384 46.59 0 44.602 0c-2.018 0-3.192 1.384-3.192 2.977 0 1.594 1.174 2.978 3.192 2.978zm27.105 15.398c0 .902-.271.992-1.386 1.083v1.263h9.186v-1.263c-1.115-.09-1.596-.18-1.596-1.083V11.79c0-3.128-1.657-4.722-4.457-4.722-2.65 0-4.518 1.533-5.542 3.158-.392-2.256-1.927-3.158-4.277-3.158-2.74 0-4.426 1.443-5.48 3.097l.12-3.097H57.07l-6.716 1.804v.933l1.596 1.022v10.526c0 .902-.482.992-1.596 1.083v1.263h9.186v-1.263c-1.115-.09-1.386-.18-1.386-1.083V11.067c.663-.24 1.265-.42 2.048-.42 1.265 0 1.626.691 1.626 1.804v8.902c0 .902-.27.992-1.385 1.083v1.263h8.975v-1.263c-1.114-.09-1.386-.18-1.386-1.083V11.098c.663-.24 1.265-.452 2.049-.452 1.264 0 1.626.692 1.626 1.805v8.902zM88.692 7.068c-4.457 0-8.342 3.368-8.342 8.812 0 5.263 3.584 8.12 8.071 8.12 3.945 0 6.324-2.256 7.168-5.745l-.632-.39c-1.145 1.473-2.59 2.105-4.488 2.105-2.65 0-4.518-2.106-4.518-5.414h9.547v-.752c0-3.94-2.288-6.736-6.806-6.736zM88.3 8.39c1.446 0 1.928 1.714 1.928 4.691h-4.246c.12-2.827.813-4.691 2.318-4.691zm15.962-5.203h-1.325C101.25 5.293 98.9 7.068 96.34 7.97v1.113h1.626v9.864c0 3.61 2.018 5.053 4.91 5.053 2.529 0 4.306-1.083 5.51-3.098l-.481-.752c-.693.481-1.386.752-2.108.752-1.024 0-1.536-.571-1.536-1.865V9.083h3.342V7.368h-3.342v-4.18zm12.589 9.835c1.294-.782 3.071-.843 5-.843h.782V7.58c-.332-.3-.844-.511-1.596-.511-1.928 0-3.042 1.083-4.186 4.691l.12-4.691h-1.205l-6.716 1.804v.933l1.597 1.022v10.526c0 .902-.483.992-1.597 1.083v1.263h10.15v-1.263c-1.687-.24-2.35-.331-2.35-1.654v-7.76zm14.395-5.955h-1.084l-6.716 1.804v.933l1.596 1.022v10.526c0 .902-.482.992-1.596 1.083v1.263h9.396v-1.263c-1.114-.09-1.596-.18-1.596-1.083V7.068zm-3.012-1.113c1.988 0 3.193-1.384 3.193-2.978 0-1.593-1.205-2.977-3.193-2.977-2.017 0-3.192 1.384-3.192 2.977 0 1.594 1.175 2.978 3.192 2.978zm11.053 7.82c0-3.008.963-5.264 2.65-5.264 1.326 0 1.807 1.173 1.807 2.977 0 .512-.03 1.083-.12 1.805h3.102c.693-.3 1.415-1.052 1.415-2.285 0-2.798-2.65-3.94-5.722-3.94-5.12 0-8.493 3.819-8.493 8.962 0 4.993 3.343 7.97 7.62 7.97 3.493 0 6.054-1.655 7.047-5.534l-.723-.451c-.933 1.323-2.198 1.865-3.915 1.865-2.981 0-4.668-2.316-4.668-6.106zM155.851 24c4.217 0 6.957-2.046 6.957-5.684 0-3.46-2.018-4.692-5.782-5.925-1.838-.601-2.71-1.053-2.71-2.256 0-1.082.842-1.714 2.047-1.714 2.078 0 3.434 1.744 3.735 3.64h1.415V8.45c-1.295-.842-3.222-1.383-5.3-1.383-3.765 0-6.476 1.924-6.476 5.503 0 3.158 1.898 4.662 5.391 5.684 1.928.572 3.102 1.023 3.102 2.497 0 1.263-1.084 1.894-2.44 1.894-2.318 0-3.945-1.834-4.487-4.24h-1.535l.18 4.06c1.355.932 3.283 1.534 5.903 1.534zm8.463-3.338c0 1.984 1.476 3.338 3.343 3.338S171 22.646 171 20.662c0-1.985-1.476-3.37-3.343-3.37s-3.343 1.385-3.343 3.37z"/>
                <circle cx="167.5" cy="20.5" r="3.5"/>
            </g>
        </svg>
    );
}

function handleClick() {
    console.log("clicked");
    postData('eki_redirects', {date: Date()});
}

//onClick={handleClick}

const EkiButton = () => {
    const classes = ButtonStyles();

    return (
        <Box 
            className={classes.boxStyle}>
            <Button 
                className={classes.buttonStyle}
                variant="outlined"
                href='https://ekimetrics.com/'
                target="_blank"
                rel="noreferrer"
                onClick={handleClick}>
                powered by &nbsp;
                <span>
                    <EkiSVG></EkiSVG>
                </span>
            </Button>   
        </Box>
    );
};

export default EkiButton;
